export default __webpack_public_path__ + "static/media/vote.09ca32ec.svg";